<template>
  <v-dialog
    :value="value"
    max-width="600"
    persistent
    @click:outside="$emit('cancel')"
  >
    <v-card>
      <v-card-title class="d-flex align-center py-3">
        <v-avatar size="36" color="amber lighten-4" class="mr-3">
          <v-icon color="amber darken-3">mdi-alert</v-icon>
        </v-avatar>
        <span class="text-h6">Move Unit to This Zone?</span>
        <v-spacer />
        <v-btn icon @click="$emit('cancel')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text class="pt-4">
        <!-- Unit summary -->
        <div
          v-if="unitName"
          class="move-unit-box d-flex align-center pa-3 mb-4"
        >
          <v-icon color="brown lighten-1" class="mr-3" large>
            mdi-package-variant-closed
          </v-icon>
          <div>
            <div class="font-weight-bold">{{ unitName }}</div>
            <div v-if="unitSubtitle" class="caption grey--text">
              {{ unitSubtitle }}
            </div>
          </div>
        </div>

        <!-- Current zone → target zone -->
        <div class="d-flex align-center mb-4">
          <div class="zone-pill zone-pill--from flex-grow-1">
            <div class="caption grey--text font-weight-medium">
              CURRENT ZONE
            </div>
            <div class="font-weight-bold red--text text--darken-1">
              {{ fromZone }}
            </div>
          </div>
          <v-icon class="mx-3 grey--text">mdi-arrow-right</v-icon>
          <div class="zone-pill zone-pill--to flex-grow-1">
            <div class="caption grey--text font-weight-medium">MOVE TO</div>
            <div class="font-weight-bold green--text text--darken-2">
              {{ toZone }}
            </div>
          </div>
        </div>

        <!-- Consequences -->
        <v-alert dense text color="amber darken-3" class="caption mb-3">
          <strong>{{ unitLabel }} will be removed from {{ fromZone }}</strong>
          and added to {{ toZone }}. Any zone-level alerts or video links tied
          to {{ fromZone }} will no longer apply to this unit.
        </v-alert>

        <div class="caption grey--text">
          If this is a mistake, click Cancel. You can always reassign again from
          the zone edit view.
        </div>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-3 d-flex flex-wrap" style="gap: 8px">
        <v-btn outlined class="move-action-btn" @click="$emit('cancel')">
          Cancel
        </v-btn>
        <v-btn
          color="red"
          dark
          depressed
          :loading="saving"
          class="move-action-btn"
          @click="$emit('confirm')"
        >
          Move
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Shared confirmation shown before a unit is moved out of its current zone.
// Used by the Smart Zone detail page (CardUnitsInZone) and the Smart Units
// "Update Zone Assignment" dialog, so the friction step looks identical.
export default {
  name: "DialogConfirmZoneMove",
  props: {
    value: { type: Boolean, default: false },
    unitName: { type: String, default: "" },
    unitSubtitle: { type: String, default: "" },
    fromZone: { type: String, default: "" },
    toZone: { type: String, default: "" },
    saving: { type: Boolean, default: false },
  },
  computed: {
    unitLabel() {
      return this.unitName || "This unit";
    },
  },
};
</script>

<style scoped>
.move-unit-box {
  background: #f5f5f5;
  border-radius: 6px;
}
.zone-pill {
  text-align: center;
  border-radius: 6px;
  padding: 12px;
}
.zone-pill--from {
  background: #ffebee;
  border: 1px solid #ffcdd2;
}
.zone-pill--to {
  background: #e8f5e9;
  border: 1px solid #c8e6c9;
}
/* The two action buttons split the row evenly (50 / 50) and wrap text/height
   instead of forcing a horizontal scrollbar when zone names are long. */
.move-action-btn {
  flex: 1 1 calc(50% - 8px);
  min-width: 0 !important;
  height: auto !important;
  min-height: 36px;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}
.move-action-btn ::v-deep .v-btn__content {
  white-space: normal !important;
  word-break: break-word;
  line-height: 1.25;
  max-width: 100%;
  flex: 1 1 auto;
}
</style>
